import setupWebViewJavascriptBridge from './setupWebViewJavascriptBridge';

let bridge = null;

// 初始化 bridge
function initBridge() {
    return new Promise((resolve) => {
        if (bridge) {
            resolve(bridge);
        } else {
            setupWebViewJavascriptBridge(function (b) {
                bridge = b;
                resolve(bridge);
            });
        }
    });
}

function encryptV2(params, resolve) {
    initBridge().then(() => {
        if (!bridge) {
            console.error('Bridge not initialized');
            resolve(params);
            return;
        }

        // 添加超时机制，默认 3 秒
        const TIMEOUT = 3000;
        let timeoutId = null;
        let resolved = false;

        const timeoutHandler = () => {
            if (!resolved) {
                resolved = true;
                console.warn('encryptV2: bridge callHandler timeout, using original params');
                resolve(params);
            }
        };

        timeoutId = setTimeout(timeoutHandler, TIMEOUT);

        bridge.callHandler(
            "getSign",
            {
                query: { ...params }, //请求参数对
            },
            (str) => {
                if (!resolved) {
                    resolved = true;
                    clearTimeout(timeoutId);  // 清除超时定时器
                    const signObj = typeof str === "string" ? JSON.parse(str) : str;
                    resolve({...params, ...signObj});
                }
            },
        );
    }).catch((error) => {
        console.error('encryptV2 error:', error);
        resolve(params);
    });
}
export default encryptV2;


// WEBPACK FOOTER //
// ./src/components/plugin/lib/encryptV2.js